<template>
    <el-drawer v-model="drawer" title="系统日志" direction="rtl">
        <div class="item" v-for="log in list" :key="log.timestamp">
            <div class="note">
                <div class="level">
                    <el-tag :type="getTagType(log.level)">{{ log.level.toUpperCase() }}</el-tag>
                </div>
                <div class="timestamp">{{ formatTime(log.timestamp) }}</div>
            </div>
            <div class="title">{{ log.title }}</div>
            <div class="message">{{ log.message }}</div>
        </div>
    </el-drawer>
</template>
<style scoped>
.item {
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #383838;
}

.note {
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-items: center;
    margin-bottom: 10px;
}

.level {
    width: 100px;
}

.timestamp {
    flex: 1;
    text-align: right;
    color: #409eff;
}

.title {
    margin-bottom: 10px;
}

.message {
    color: #848383;
}

</style>
<script setup>
import { ref } from 'vue'
import { useLogStore } from '@/stores/log'
import dayjs from 'dayjs'

const logStore = useLogStore()
const drawer = ref(false)
const list = ref([])

// 日志等级到标签类型的映射
const getTagType = (level) => {
    const typeMap = {
        'info': 'info',
        'warning': 'warning',
        'error': 'danger'
    }
    return typeMap[level] || 'info'
}

// 格式化时间戳
const formatTime = (timestamp) => {
    return dayjs(timestamp).format('YYYY-MM-DD HH:mm:ss')
}

const showDrawer = () => {
    drawer.value = true
    list.value = logStore.logs.sort((a, b) => b.timestamp - a.timestamp)
}

defineExpose({ showDrawer })
</script>